export const convertData = async (data, conversions, debug = false) => {
    return new Promise(async (resolve, reject) => {
        if (!data) return;

        if (Array.isArray(data)) {
            const convertedData = await Promise.all(data.map(async (item) => {
                return await convertData(item, conversions);
            }));

            if (debug) {
                console.error('Is array: ', convertedData);
            }

            resolve(convertedData);
        } else if (typeof data === 'object') {
            let convertedData = data;
            for (const conversion of conversions) {
                const from = conversion.from.split('.');
                const to = conversion.to.split('.');

                let value = data;
                
                for (const key of from) {
                    if (Array.isArray(value)) {
                        value = value.map((item) => {
                            if (!item[key]) return item;

                            return item[key];
                        });
                    } else {
                        if (!value[key]) {
                            value = value;
                        } else {
                            value = value[key];
                        }
                    }
                }

                let convertedValue = value;
                for (let i = to.length - 1; i >= 0; i--) {
                    const key = to[i];

                    convertedValue = {
                        [key]: convertedValue,
                    };

                }

                delete convertedData[from[0]];

                convertedData = {
                    ...convertedData,
                    ...convertedValue,
                };
            }

            if (debug) {
                console.error('Is object: ', convertedData);
            }

            resolve(convertedData);
        }
    });
};

export const convertDynamicData = async (data, values, debug = false) => {
    return new Promise(async (resolve, reject) => {
        if (!data) return;

        if (Array.isArray(data)) {
            const convertedData = await Promise.all(data.map(async (item) => {
                return await convertDynamicData(item, values);
            }));

            resolve(convertedData);
        } else if (typeof data === 'object') {
            let convertedData = data;
            for (const key in data) {
                if (debug) {
                    console.error('key', key);
                }

                if (typeof data[key] === 'string') {
                    for (const valueKey in values) {
                        const value = values[valueKey];

                        if (data[key].includes(`[${valueKey}]`)) {
                            convertedData[key] = data[key].replaceAll(`[${valueKey}]`, value);
                        }
                    }
                } else if ((!Array.isArray(data[key]) && typeof data[key] !== 'object') || data[key] === null || typeof data[key] === 'number' || typeof data[key] === 'boolean') {
                    convertedData[key] = data[key];
                } else {
                    if (debug) {
                        console.error('else', data[key]);
                    }

                    convertedData[key] = await convertDynamicData(data[key], values);
                }
            }

            resolve(convertedData);
        }
    });
};

export default {
    convertData,
    convertDynamicData,
}